// src/pages/Subscription/SubscriptionSuccessPage.jsx
import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, CardBody, Button, Spinner } from 'reactstrap';
import { useLocation, useHistory, Link } from 'react-router-dom';
import { get } from 'helpers/api_helper';
import {
  RiCheckboxCircleFill,
  RiVipCrownLine,
  RiArrowRightLine,
  RiPrinterLine,
  RiDashboardLine,
  RiShieldCheckLine,
} from 'react-icons/ri';
import moment from 'moment';

const SubscriptionSuccessPage = () => {
  const location = useLocation();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [txDetails, setTxDetails] = useState(null);

  const query = new URLSearchParams(location.search);
  const txnid = query.get('txnid');
  const planName = query.get('plan');

  useEffect(() => {
    const verifyTx = async () => {
      if (txnid) {
        try {
          const res = await get(`/subscriptions/verify-transaction?txnid=${txnid}`);
          if (res?.success && res?.body) {
            setTxDetails(res.body);
          }
        } catch (err) {
          console.warn('Verify transaction notice:', err);
        }
      }
      setLoading(false);
    };

    verifyTx();
  }, [txnid]);

  return (
    <div className="page-content d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
      <Container>
        <Row className="justify-content-center">
          <Col md={7} lg={6}>
            <Card className="border-0 shadow-lg text-center overflow-hidden" style={{ borderRadius: 16 }}>
              <div className="bg-success py-4 text-white">
                <RiCheckboxCircleFill style={{ fontSize: 64 }} />
                <h4 className="text-white font-weight-bold mt-2 mb-0">Subscription Activated!</h4>
                <p className="text-white-50 font-size-13 mb-0">Payment processed successfully via PayU India</p>
              </div>

              <CardBody className="p-4">
                {loading ? (
                  <div className="py-4">
                    <Spinner color="success" size="md" />
                    <p className="text-muted font-size-13 mt-2">Finalizing subscription license...</p>
                  </div>
                ) : (
                  <div>
                    <div className="p-3 bg-light rounded text-start mb-4 border font-size-13">
                      <div className="d-flex justify-content-between mb-2">
                        <span className="text-muted">Transaction ID:</span>
                        <code className="text-dark font-weight-bold">{txnid || txDetails?.payu_txnid || 'Confirmed'}</code>
                      </div>
                      <div className="d-flex justify-content-between mb-2">
                        <span className="text-muted">Subscription Tier:</span>
                        <strong className="text-primary">{planName || txDetails?.plan?.name || 'SaaS Pro'}</strong>
                      </div>
                      <div className="d-flex justify-content-between mb-2">
                        <span className="text-muted">Payment Mode:</span>
                        <span className="text-uppercase">{txDetails?.payu_mode || 'PayU India'}</span>
                      </div>
                      <div className="d-flex justify-content-between mb-2">
                        <span className="text-muted">Amount Paid:</span>
                        <strong className="text-dark">
                          ₹ {Number(txDetails?.amount || query.get('amount') || 0).toLocaleString('en-IN')}
                        </strong>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span className="text-muted">Payment Timestamp:</span>
                        <span>{moment().format('DD MMM YYYY, hh:mm A')}</span>
                      </div>
                    </div>

                    <div className="alert alert-success font-size-12 d-flex align-items-center justify-content-center gap-2 mb-4">
                      <RiShieldCheckLine className="font-size-16" />
                      <span>
                        A payment confirmation and tax invoice has been sent to your registered clinic email and WhatsApp.
                      </span>
                    </div>

                    <div className="d-flex gap-2 justify-content-center">
                      <Button
                        color="light"
                        onClick={() => window.print()}
                        className="d-flex align-items-center gap-1"
                      >
                        <RiPrinterLine /> Print Receipt
                      </Button>
                      <Button
                        color="primary"
                        tag={Link}
                        to="/subscription"
                        className="d-flex align-items-center gap-1"
                      >
                        Manage Subscription <RiArrowRightLine />
                      </Button>
                      <Button
                        color="success"
                        tag={Link}
                        to="/dashboard"
                        className="d-flex align-items-center gap-1"
                      >
                        <RiDashboardLine /> Go to Dashboard
                      </Button>
                    </div>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SubscriptionSuccessPage;
